import drillingRigGreen from 'images/rigs/rig-green.png';
import drillingRigRed from 'images/rigs/rig-red.png';
import drillingRigGray from 'images/rigs/rig-gray.png';

export const addDrillingRigImages = (map: mapboxgl.Map) => {
  const rigs = [
    { id: 'horizontal-drilling', url: drillingRigGreen },
    { id: 'horizontal-down', url: drillingRigRed },
    { id: 'horizontal-not-reporting', url: drillingRigGray },
    { id: 'horizontal-not-tracking', url: drillingRigGray },
    { id: 'horizontal-unreported-status', url: drillingRigGray },
    { id: 'vertical-drilling', url: drillingRigGreen },
    { id: 'vertical-down', url: drillingRigRed },
    { id: 'vertical-not-reporting', url: drillingRigGray },
    { id: 'vertical-not-tracking', url: drillingRigGray },
    { id: 'vertical-unreported-status', url: drillingRigGray },
  ];

  rigs.forEach(({ id, url }) => {
    if (!map.hasImage(id)) {
      map.loadImage(url, (error, image) => {
        if (error) {
          console.error(`Failed to load ${id}:`, error);
          return;
        }
        if (!image) return;
        if (!map.hasImage(id)) {
          map.addImage(id, image);
        }
      });
    }
  });
};
